import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { EdpLoaderModule } from "@edp-components/edp-loader/edp-loader.module";
import { EdpRoundedModule } from "@edp-components/edp-rounded-progress/edp-rounded-progress.module";
import { TranslateModule } from "@ngx-translate/core";
import { EdpOverlayMoreInfoComponent } from "./edp-overlay-more-info.component";

@NgModule({
    declarations: [EdpOverlayMoreInfoComponent],
    imports: [CommonModule, TranslateModule, EdpRoundedModule, EdpLoaderModule, ReactiveFormsModule],
    exports: [EdpOverlayMoreInfoComponent],
})
export class EdpOverlayMoreInfoModule {}
